export default __webpack_public_path__ + "static/media/wave.7850c152.png";